import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import operationTypes from 'constants/operationTypes';

import MandatoryField from 'modules/_shared/components/MandatoryField';
import InputRadio from 'modules/_shared/components/InputRadio';
import { HistoryMovementsViewProvider } from 'modules/_shared/components/HistoryMovementsView/context/HistoryMovementsViewContext';
import HistoryMovementsView from 'modules/_shared/components/HistoryMovementsView';

import { useRenumerationModal } from '../context/RenumerationModalContext';

import AutomaticRenumerationMode from './AutomaticRenumerationMode';
import ManualRenumerationMode from './ManualRenumerationMode';

const RenumerationMovementsView: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useRenumerationModal();

  const hasHistoryMovements = data.historyMovements.length > 0;

  return (
    <div>
      <div className="form-group">
        <label className="form-label">
          {t('HowDoYouWantToAssignTheNe')} <MandatoryField />
        </label>

        <div className="row">
          <div className="col-md-6">
            <InputRadio
              id="automatic"
              checked={data.isAutomaticRenumeration}
              label={t('AutomaticBySttok')}
              onChange={actions.handleChangeRenumerationMode}
              disabled={hasHistoryMovements}
            />
          </div>

          <div className="col-md-6">
            <InputRadio
              id="manual"
              checked={!data.isAutomaticRenumeration}
              label={t('Manual')}
              onChange={actions.handleChangeRenumerationMode}
              disabled={hasHistoryMovements}
            />
          </div>
        </div>
      </div>
      {data.isAutomaticRenumeration ? (
        <AutomaticRenumerationMode />
      ) : (
        <ManualRenumerationMode />
      )}

      {hasHistoryMovements && (
        <div className="mt-4">
          <HistoryMovementsViewProvider
            historyMovements={data.historyMovements}
            operationType={operationTypes.RENUMERATION}
          >
            <HistoryMovementsView />
          </HistoryMovementsViewProvider>
        </div>
      )}
    </div>
  );
};

export default RenumerationMovementsView;
